// @flow

/**
 * Module dependencies.
 */

import { branch } from 'core/utils';
import { colors, defaultTransition, naviconTransition, states, units } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import { ifProp } from 'styled-tools';
import { position, size } from 'polished';
import { setBodyOverflow } from 'client/core/utils';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  active: boolean,
  fixed: boolean,
  toggle: Function
};

/**
 * `Button` component.
 */

const Button = styled.span`
  ${size('24px', '24px')};

  cursor: pointer;
  display: inline-block;
  float: right;
  margin-left: ${units(3)};
  opacity: 1;
  position: relative;
  transition: opacity ${defaultTransition};

  ${states.interaction`opacity: 0.7`};
`;

/**
 * `Hamburger` component.
 */

const Hamburger = styled.span`
  ${position('absolute', '0', null, '0', '0')};
  ${size('24px', '24px')};

  margin: auto;
`;

/**
 * `Bar` component.
 */

const Bar = styled.span`
  position: relative;
  transform: translateY(12px);
  transition: all 0ms 300ms;

  &,
  &:after,
  &:before {
    ${size('2px', '24px')};

    background-color: ${ifProp('sticky', colors.brandSecondary, colors.white)};
    display: block;
    transition: background-color ${defaultTransition};
  }

  &:after,
  &:before {
    content: '';
    left: 0;
    position: absolute;
  }

  &:before {
    bottom: 6px;
    transition: bottom ${naviconTransition.slow}, transform ${naviconTransition.fast};
  }

  &:after {
    top: 6px;
    transition: top ${naviconTransition.slow}, transform ${naviconTransition.fast};
  }

  &.active {
    background-color: transparent;

    &:before {
      bottom: 0;
      transform: rotate(-45deg);
      transition: bottom ${naviconTransition.fast}, transform ${naviconTransition.slow};
    }

    &:after {
      top: 0;
      transform: rotate(45deg);
      transition: top ${naviconTransition.fast}, transform ${naviconTransition.slow};
    }
  }
`;

/**
 * `Navicon` component.
 */

function Navicon(props: Props): React$Element<*> {
  const { active, fixed, toggle } = props;

  const onClick = () => {
    toggle();
    setBodyOverflow(!active);
  };

  return (
    <Button onClick={onClick}>
      <Hamburger>
        <Bar
          className={branch(active, 'active')}
          sticky={fixed}
        />
      </Hamburger>
    </Button>
  );
}

/**
 * Export `Navicon` component.
 */

export default compose(
  defaultProps({
    active: false
  })
)(Navicon);



// WEBPACK FOOTER //
// ../src/client/components/navbar/navicon.js